import { Reveal } from "@/components/Reveal";
import { AUTHORITY_FRAMEWORK } from "@/data/content";

export default function AuthorityFramework() {
  return (
    <section className="py-24 md:py-36 bg-navy text-warm grain" data-testid="authority-framework-section">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <span className="overline inline-flex items-center gap-3 text-warm/60">
                <span className="w-8 h-px bg-gold" />02 — The Framework
              </span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-heading font-light tracking-tight text-4xl md:text-5xl leading-[1.05]">
                From visibility<br />to influence.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 text-warm/70 leading-relaxed max-w-sm font-body">
                The Authority Framework™ — we help organizations move through each stage intentionally,
                rather than chasing isolated visibility opportunities.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7 lg:col-start-6">
          <div className="divide-y divide-white/10 border-y border-white/10">
            {AUTHORITY_FRAMEWORK.map((step, i) => (
              <Reveal
                key={step.n}
                delay={i * 0.05}
                className="group py-10 md:py-12 flex items-baseline gap-8 md:gap-14"
              >
                <span className="font-heading text-gold text-sm tracking-widest pt-2">{step.n}</span>
                <div>
                  <h3 className="font-heading font-light text-3xl md:text-5xl leading-none">{step.title}</h3>
                  <p className="mt-4 text-warm/65 leading-relaxed max-w-md font-body">{step.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
